import {ReactElement} from "react";

export function ProcessorCard({children, isSelected}: { children: ReactElement[], isSelected: boolean }) {
    return (
        <div className={`smart-trigger-processor-card ${isSelected ? "active-processor" : ""}`}>
            {children}
        </div>
    )
}
